export default {
      id: "ic_substitutes-usage",
      viewBox: "0 0 14 13",
      url: "/" + "images/icons.3.109.2.svg#ic_substitutes-usage",
      toString: function () {
        return this.url;
      }
    }